import { Box } from '@chakra-ui/layout';
import { Grid, GridItem } from '@telescope/cassini-ui';
import { Tile } from './Tile';
import { useWidget } from '@telescope/cassini-hooks';
import { useMemo } from 'react';
import { useBingo } from '../providers';
import { Open } from 'generated-types/widget';

export const Card = () => {
  const { data } = useWidget({ select: (data: Open) => data.snapshot.snapshot_views.bingo });
  const { styles: { centerCard }, settings: {isCardRounded}} = data!;
  const { getCard } = useBingo();
  const card = useMemo(() => getCard(), []);

  return (
    <Grid templateColumns="repeat(5, minmax(0, 1fr))" gap="3px" rounded={isCardRounded ? '3xl' : 'none'} overflow='hidden'>
      {card.map((row, rI) => (
        row.map((tile, tI) => (
            <GridItem sx={{ aspectRatio: '0.9' }} overflow="hidden" key={`${rI}${tI}`}>
                { tile?.center?
                <Box borderRadius={0} w="100%" h="100%" bgSize="contain" bgPosition="center" {...centerCard}/> :
                <Tile data={tile} row={rI} column={tI} /> }
            </GridItem>
          ))
      ))}
    </Grid>
  )
}